import React from "react";
import { Hero } from "./components/Hero";
import { PainPoints } from "./components/PainPoints";
import { Modules } from "./components/Modules";
import { Reviews } from "./components/Reviews";
import { Bonuses } from "./components/Bonuses";
import { Compare } from "./components/Compare";
import { ShortTestimonials } from "./components/ShortTestimonials";
import { FinalOffer } from "./components/FinalOffer";
import { Objections } from "./components/Objections";
import { StickyBar } from "./components/StickyBar";
import { PurchasePopup } from "./components/PurchasePopup";
import { IMAGES } from "./lib/data";
export function App() {
  return <div className="relative min-h-full w-full bg-slate-100" data-id="element-0" data-mp="31ctdnmtavs6j">
      {/* Fondo: consultorio de fisioterapia con efecto borroso */}
      <div className="pointer-events-none fixed inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: `url(${IMAGES.clinicBg})`,
      filter: "blur(12px)",
      transform: "scale(1.1)"
    }} aria-hidden="true" data-id="element-1" data-mp="28u5zkrcq1dey" />
      <div className="pointer-events-none fixed inset-0 z-0 bg-slate-100/85" aria-hidden="true" data-id="element-2" data-mp="3ihv1ac76whht" />

      {/* Contenido */}
      <main className="relative z-10 mx-auto max-w-md pb-28" data-id="element-3" data-mp="3rcj5s04xxv5k">
        <Hero data-id="element-4" data-mp="3rd19fhtxnbni" />
        <PainPoints data-id="element-5" data-mp="3relumgucxi8p" />
        <Modules data-id="element-6" data-mp="5orh0l86u6j" />
        <Reviews data-id="element-7" data-mp="6817u0q2c9h" />
        <Bonuses data-id="element-8" data-mp="4n6a3ahwrb3" />
        <Compare data-id="element-9" data-mp="56m9egl55mh" />
        <ShortTestimonials data-id="element-10" data-mp="7st1bvnjh3n" />
        <FinalOffer data-id="element-11" data-mp="2zllduyaeeel5" />
        <Objections data-id="element-12" data-mp="2zm4v0cs84yy4" />

        <footer className="px-4 pb-6 pt-8 text-center" data-id="element-13" data-mp="2zmwj72jhrued">
          <p className="text-xs text-slate-400" data-id="element-14" data-mp="33lwxq8uxsavk">
            © {new Date().getFullYear()} Megapack Fisio Eficiente · Producto digital ·
            Todas las compras se procesan de forma segura.
          </p>
        </footer>
      </main>

      <PurchasePopup data-id="element-15" data-mp="3dmfmni1cyhkc" />
      <StickyBar data-id="element-16" data-mp="3dii4ozqinw21" />
    </div>;
}